import React from 'react';
import {
  GridRowParams,
  getGridStringOperators,
  getGridSingleSelectOperators,
} from '@mui/x-data-grid';
import { IconButton, Link } from '@material-ui/core';
import Warning from '@material-ui/icons/Warning';
import CheckCircle from '@material-ui/icons/CheckCircle';
import EditIcon from '@material-ui/icons/Edit';
import { CustomChip } from '../components/CustomChip';
import { ChipSet } from '../components/ChipSet';

const stringOperators = getGridStringOperators().filter(op =>
  ['contains'].includes(op.value),
);
const singleSelectOperators = getGridSingleSelectOperators().filter(
  op => op.value === 'is',
);

export const UserColumns = [
  {
    flex: 1,
    field: 'email',
    headerName: 'User Email',
    resizable: true,
    disableColumnMenu: true,
    sortable: true,
    filterOperators: stringOperators,
    renderCell: (params: GridRowParams) => (
      <Link href={`mailto:${params.row.email}`}>{params.row.email}</Link>
    ),
  },
  {
    flex: 1,
    field: 'username',
    headerName: 'User Name',
    resizable: true,
    disableColumnMenu: true,
    sortable: true,
    filterOperators: stringOperators,
  },
  {
    flex: 1,
    field: 'organizationNames',
    headerName: 'Teams',
    minWidth: 375,
    resizable: true,
    disableColumnMenu: true,
    sortable: false,
    filterOperators: stringOperators,
    renderCell: (
      params: GridRowParams & { colDef: { organizations: any[] } },
    ) => <ChipSet max={3} values={params.row.organizationNames} />,
  },
  {
    flex: 1,
    minWidth: 135,
    field: 'isInternal',
    headerName: 'Access Category',
    resizable: true,
    disableColumnMenu: true,
    sortable: true,
    type: 'singleSelect',
    valueOptions: [
      { value: true, label: 'Internal' },
      { value: false, label: 'External' },
    ],
    filterOperators: singleSelectOperators,
    renderCell: (params: GridRowParams) => (
      <CustomChip
        label={params.row.isInternal ? 'Internal' : 'External'}
        variant="outlined"
        isInternal={params.row.isInternal}
      />
    ),
  },
  {
    flex: 1,
    minWidth: 435,
    field: 'attributes',
    headerName: 'Permissions',
    resizable: true,
    disableColumnMenu: true,
    sortable: false,
    filterOperators: stringOperators,
    renderCell: (params: GridRowParams) => (
      <ChipSet max={1} values={params.row.attributes} />
    ),
  },
  {
    flex: 1,
    field: 'isActive',
    headerName: 'Status',
    resizable: true,
    disableColumnMenu: true,
    sortable: true,
    type: 'singleSelect',
    valueOptions: [
      { value: true, label: 'Active' },
      { value: false, label: 'Inactive' },
    ],
    filterOperators: singleSelectOperators,
    renderCell: (params: GridRowParams) => (
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          height: '100%',
        }}
      >
        {params.row.isActive ? (
          <>
            <CheckCircle htmlColor="green" /> Active
          </>
        ) : (
          <>
            <Warning color="error" />
            Deactivated
          </>
        )}
      </span>
    ),
  },
  {
    flex: 1,
    field: 'edit',
    headerName: 'Edit',
    resizable: true,
    disableColumnMenu: true,
    sortable: false,
    filterable: false,
    renderCell: (
      params: GridRowParams & { colDef: { onClick: (rowId: string) => {} } },
    ) => (
      <IconButton
        type="button"
        onClick={e => {
          e.stopPropagation();
          params.colDef.onClick(params.row.id);
        }}
      >
        <EditIcon color="primary" />
      </IconButton>
    ),
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    filterable: true,
    hideable: false,
    filterOperators: stringOperators,
  },
  {
    field: 'companyName',
    headerName: 'Company Name',
    filterable: true,
    hideable: false,
    filterOperators: stringOperators,
  },
];
